function isEnumValue<T extends Record<string, string | number>>(enumObj: T, value: string | number): value is T[keyof T] {
  const normalizedValue = String(value).toLowerCase();

  return Object.values(enumObj)
    .map((v) => String(v).toLowerCase())
    .includes(normalizedValue);
}

function parseEnumValue<T extends Record<string, string | number>>(enumObj: T, value: string | number): T[keyof T] | undefined {
  const normalizedValue = String(value).toLowerCase();

  const match = Object.values(enumObj).find((v) => String(v).toLowerCase() === normalizedValue);

  return match as T[keyof T] | undefined;
}

export { isEnumValue, parseEnumValue };
